export default {
      id: "unit_dashboard__status-usage",
      viewBox: "0 0 30 33",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__status",
      toString: function () {
        return this.url;
      }
    }